'use client';
import styled from 'styled-components';
import Header from '../atoms/Header';
import ContentText from '../atoms/ContentText';
import useWidth from '@/util/useWidth';

type Props = {
  title: React.ReactNode;
  subtitle?: string;
  direction?: 'row' | 'col';
  barColor?: string;
  className?: string;
  largerMobileTitle?: boolean;
  topMobileTitle?: boolean;
};

const TitlePc: React.FC<Props> = (props) => {
  const { isMobile } = useWidth();
  return (
    <>
      <div className={props.className}>
        <Container barColor={props.barColor}>
          <Header
            type={
              isMobile
                ? props.largerMobileTitle
                  ? 'h-m-sp'
                  : props.topMobileTitle
                  ? 'h-s-sp-top-title'
                  : 'h-s-sp-title'
                : 'h-xl'
            }
          >
            {props.title}
          </Header>
          {props.subtitle && props.direction == 'row' ? (
            <ContentText className="subtitle">{props.subtitle}</ContentText>
          ) : null}
        </Container>
        {props.subtitle && props.direction != 'row' ? (
          <div>
            <ContentText type={isMobile ? 'label-m' : 'label-l'}>
              {props.subtitle}
            </ContentText>
          </div>
        ) : null}
      </div>
    </>
  );
};
const Container = styled.div<{ barColor?: string }>`
  display: inline-flex;
  align-items: flex-end;
  justify-content: flex-start;
  border-bottom: 2px solid;
  border-color: ${(props) =>
    props.barColor || 'var(--color-dull-green, #b5c7c3)'};
  .subtitle {
    padding-left: 16px;
  }
`;
export default TitlePc;
